"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _formSelect = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/form-select.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _formSelect.default);
/** A **FormSelect** is similar to a **Dropdown** but is more commonly used within a form. It can also be
set to a disabled state. */

var FormSelect = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames;

  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      state = _ref.state,
      props = (0, _objectWithoutProperties2.default)(_ref, ["disabled", "children", "className", "compact", "cssNamespace", "state"]);
  var formSelectClasses = classnames("".concat(cssNamespace, "-form-select"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "is-".concat(state), state), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-form-select--compact"), compact), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, props, {
    className: formSelectClasses,
    disabled: disabled,
    ref: ref
  }), children);
});

FormSelect.displayName = 'FormSelect';
process.env.NODE_ENV !== "production" ? FormSelect.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** State of validation: 'error', 'warning', 'information', 'success' */
  state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES)
} : void 0;

var _default = (0, _withStyles.default)(FormSelect);

exports.default = _default;